import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var ProjectHelper =
/*#__PURE__*/
function () {
  function ProjectHelper() {
    _classCallCheck(this, ProjectHelper);

    _defineProperty(this, "STATUSES", {
      ACTIVE: {
        label: "Active",
        value: 0
      },
      NOT_ACTIVE: {
        label: "Inactive",
        value: 1
      },
      UNDER_CONSTRUCTION: {
        label: "Under Construction",
        value: 2
      },
      CONDITIONAL: {
        label: "Conditional",
        value: 3
      },
      FIRM: {
        label: "Firm",
        value: 4
      },
      DECONTROL: {
        label: "Decontrol",
        value: 5
      },
      DELETED: {
        label: "Deleted",
        value: 6
      }
    });
  }

  _createClass(ProjectHelper, [{
    key: "GetStatusArray",
    value: function GetStatusArray() {
      return [this.STATUSES.ACTIVE, this.STATUSES.NOT_ACTIVE, this.STATUSES.UNDER_CONSTRUCTION, this.STATUSES.CONDITIONAL, this.STATUSES.FIRM, this.STATUSES.DECONTROL, this.STATUSES.DELETED];
    }
  }, {
    key: "GetNormalStatusArray",
    value: function GetNormalStatusArray() {
      return [this.STATUSES.ACTIVE, this.STATUSES.NOT_ACTIVE, this.STATUSES.UNDER_CONSTRUCTION, this.STATUSES.CONDITIONAL, this.STATUSES.FIRM, this.STATUSES.DECONTROL];
    }
  }, {
    key: "GetStatusLabel",
    value: function GetStatusLabel(id) {
      if (id < 0 || id >= this.GetStatusArray().length) return this.GetStatusArray()[0].label;
      var status = this.GetStatusArray()[id];
      return status ? status.label : null;
    }
  }, {
    key: "GetProjectNumber",
    value: function GetProjectNumber(accountNumberObj) {
      if (accountNumberObj.mhdcNumber) return "MHDC #" + accountNumberObj.mhdcNumber;
      return "LIHTC #" + accountNumberObj.lihtC1;
    }
  }]);

  return ProjectHelper;
}();

export default new ProjectHelper();